import React from "react"
import { Calendar } from "react-bootstrap-icons"
import parse from 'html-react-parser';

export const ContentView: React.FC<{ content: any, hideTitle?: boolean }> = ({ content, hideTitle }) => {
    if (!content)
        return <></>

    var fecha = new Date(content.publish_date)
    return <>
        {hideTitle !== true && <>
            <h3>{content.title}</h3>
            <div className="small text-muted mb-2">
                <Calendar /> Publicado el {fecha.toLocaleDateString("es-CL", {
                    weekday: "long",
                    day: "2-digit",
                    month: "long",
                    year: "numeric"
                })}
            </div>
        </>}
        <div>{parse(content.content)}</div>
    </>
}